import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import {
  RotateLeftOutlined,
  RotateRightOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";

interface FilePreviewModalProps {
  isVisible: boolean;
  onClose: () => void;
  fileUrl: string;
  fileName: string;
  handleUpload: any;
  showUploadButton: boolean;
  documentType?: string;
  key?: any;
  isLoading?: boolean;
}

const FilePreviewModal: React.FC<FilePreviewModalProps> = ({
  isVisible,
  onClose,
  fileUrl,
  fileName,
  handleUpload,
  showUploadButton,
  documentType,
  isLoading,
}) => {
  const isPdf = fileName.toLowerCase().endsWith(".pdf");

  const [zoomLevel, setZoomLevel] = useState(1);
  const [rotationAngle, setRotationAngle] = useState(0);

  useEffect(() => {
    setZoomLevel(1);
    setRotationAngle(0);
  }, [fileUrl]);

  const handleZoomIn = () => {
    setZoomLevel((prevZoom) => Math.min(prevZoom + 0.1, 3));
  };

  const handleZoomOut = () => {
    setZoomLevel((prevZoom) => Math.max(prevZoom - 0.1, 0.5));
  };

  const handleRotateLeft = () => setRotationAngle((prev) => prev - 90);
  const handleRotateRight = () => setRotationAngle((prev) => prev + 90);

  return (
    <div className="preview-modal">
      <Modal
        title={`Preview: ${fileName}`}
        visible={isVisible}
        onCancel={onClose}
        footer={[
          showUploadButton && ( // Conditionally render the Upload button
            <Button
              key="upload"
              type="primary"
              onClick={() => handleUpload()}
              loading={isLoading}
              style={{ marginTop: "0.6rem" }}
            >
              Upload
            </Button>
          ),
          <Button key="close" onClick={onClose} style={{ marginTop: "0.8rem" }}>
            Close
          </Button>,
        ]?.filter(Boolean)} // Filter out false values (when Upload button is not shown)
        width={1000}
        bodyStyle={{ height: "120vh" }}
        wrapClassName="preview-modal"
      >
        {isPdf ? (
          <object
            data={fileUrl}
            type="application/pdf"
            width="100%"
            height="100%"
          >
            <embed
              src={fileUrl}
              type="application/pdf"
              width="100%"
              height="100%"
            />
            <p>
              This browser does not support PDFs. Please download the PDF to
              view it:
              <a href={fileUrl} download={fileName}>
                Download PDF
              </a>
              .
            </p>
          </object>
        ) : (
          <>
            <div
              style={{
                overflow: "auto",
                width: "100%",
                height: "120vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                marginTop: 20,
              }}
            >
              <div
                style={{
                  minWidth: `${100 * zoomLevel}%`,
                  minHeight: `${100 * zoomLevel}%`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={fileUrl}
                  alt={fileName}
                  // style={{
                  //   maxWidth: "100%",
                  //   maxHeight: "100%",
                  //   objectFit: "contain",
                  // }}
                  // style={{
                  //   transform: `scale(${zoomLevel}) rotate(${rotationAngle}deg)`,
                  //   transformOrigin: "top center",
                  //   transition: "transform 0.3s ease",
                  //   maxWidth: "100%",
                  //   maxHeight: "100%",
                  //   // objectFit: "contain",
                  // }}
                  style={{
                    transform: `scale(${zoomLevel}) rotate(${rotationAngle}deg)`,
                    transition: "transform 0.3s ease",
                    maxWidth: "none",
                    maxHeight: "none",
                    width: "100%",
                    height: "auto",
                  }}
                />
              </div>
            </div>
            <div className="zoom-controls" style={{ marginTop: "0.3rem" }}>
              <Button
                onClick={handleZoomOut}
                disabled={zoomLevel <= 0.5}
                style={{ marginRight: "0.5rem" }}
              >
                <ZoomOutOutlined />
              </Button>
              <Button onClick={handleZoomIn} disabled={zoomLevel >= 3}>
                <ZoomInOutlined />
              </Button>
              <Button onClick={handleRotateLeft} style={{ marginLeft: 8 }}>
                <RotateLeftOutlined />
              </Button>
              <Button onClick={handleRotateRight} style={{ marginLeft: 8 }}>
                <RotateRightOutlined />
              </Button>
            </div>
          </>
        )}
      </Modal>
    </div>
  );
};

export default FilePreviewModal;
